import Icon from './Icon';
import { plans } from '../constants/content';
import { SUPPORT_PHONE_TEL } from '../constants/site';

export default function Plans() {
  return (
    <section className="section section--alt" id="plans">
      <div className="container">
        <div className="sec-head sec-head--center">
          <p className="kicker">Pricing</p>
          <h2 className="sec-title">Choose Your McAfee Plan</h2>
          <p className="sec-lead">
            Every plan includes the same award-winning antivirus engine. Step up for more devices,
            identity cover, and hands-on support from our specialists.
          </p>
        </div>

        <div className="plans">
          {plans.map((plan) => (
            <article
              key={plan.id}
              className={`plan${plan.featured ? ' plan--featured' : ''}`}
            >
              {plan.badge && <span className="plan__badge">{plan.badge}</span>}

              <h3 className="plan__name">{plan.name}</h3>
              <p className="plan__tagline">{plan.tagline}</p>

              <div className="plan__price">
                <span className="plan__currency">$</span>
                <span className="plan__amount">{plan.price}</span>
                <span className="plan__strike">${plan.strike}</span>
              </div>
              <p className="plan__term">for your {plan.term}, then renews at standard rate</p>

              <span className="plan__devices">{plan.devices}</span>

              <ul className="plan__list">
                {plan.features.map((feature) => (
                  <li key={feature}>
                    <Icon name="check" size={16} strokeWidth={2.6} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href={`tel:${SUPPORT_PHONE_TEL}`}
                className={`btn btn--block ${plan.featured ? 'btn--red' : 'btn--outline'}`}
              >
                {plan.cta}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
